<template>
  <el-container style="margin-top: 20px">
    <el-aside width="150px" style="margin-top: -30px">
      <div>
        <el-select v-model="selectvalue" placeholder="全部" clearable="handleNodeClick" filterable>
          <el-option
              v-for="item in treeData"
              :key="item.selectvalue"
              :label="item.roleName"
              :value="item.roleId"
              @click="handleNodeClick">
          </el-option>
        </el-select>
      </div>
    </el-aside>
    <el-main style="margin-top: -50px">
      <div style="margin-left:  0px; display: flex">
        <el-input style="width: 15%" v-model="shuru" placeholder="请输入用户名" clearable/>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button @click="select" type="primary" plain>搜索</el-button>
        <el-button @click="chaxun" type="primary" plain>刷新</el-button>
        <el-button type="primary" @click="xinjian" plain>新建用户</el-button>
        <!--        <el-button type="primary" @click="serviceTest">接口测试</el-button>-->
      </div>
      <div style="margin-top: 20px">
        <el-table :data="tablee" v-model="dialogVisible" border>
          <el-table-column prop="userName" label="登录名" style="width: auto" min-width="80"></el-table-column>
          <el-table-column prop="userAlias" label="姓名" style="width: auto" min-width="80"></el-table-column>
          <el-table-column prop="roleName" label="角色" style="width: auto" min-width="80"></el-table-column>
          <el-table-column prop="userlock" label="账号状态" style="width: auto" min-width="100">
            <template v-slot="scope">
              <el-switch
                  v-model="scope.row.userlock"
                  active-text="激活"
                  inactive-text="锁定"
                  active-color="#13ce66"
                  :active-value="0"
                  :inactive-value="1"
                  inactive-color="#ff4949"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="capIndex" label="是否已分配头盔" style="width: auto" min-width="80">
            <template v-slot="scope">
              <span v-if="scope.row.capIndex == null || scope.row.capIndex == '' || scope.row.capIndex == ' '">未分配</span>
              <span v-if="scope.row.capIndex != null && scope.row.capIndex !== '' && scope.row.capIndex != ' '" style="color: #ff34c6">已分配</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="userSign" label="签名" style="width: auto" min-width="15%">-->
          <!--            <template v-slot="scope">-->
          <!--              <el-image style="width: 100px; height: 100px"-->
          <!--                        :src="scope.row.userSign"-->
          <!--                        :preview-src-list="[scope.row.userSign]">-->
          <!--              </el-image>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column prop="authorityId" label="操作" min-width="60" style="width: auto">
            <template v-slot="scope">
              <el-button type="primary" plain @click="update(scope.row)">编辑</el-button>
                            <el-button type="danger" @click="del(scope.row.userId)">注销</el-button>&nbsp;&nbsp;&nbsp;
<!--              <el-popconfirm title="确定注销此用户？" width="150" @confirm="del(scope.row.userId, scope.row.capIndex)">-->
<!--                <template #reference>-->
<!--                  <el-button type="danger">注销</el-button>-->
<!--                </template>-->
<!--              </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination v-model:currentPage="currentPage"
                     v-model:page-size="pageSize"
                     :page-sizes="[10, 20]"
                     :small="small"
                     :background="background"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
                     :prev="prev"
                     :pager="pager"
                     :next="next"
                     :jumper="jumper"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"/>
      <div>
        <el-dialog v-model="dialogFormVisible" title="添加用户" :lock-scroll="false" width="80%" draggable>
          <el-form :model="form" ref="form" :rules="rules" status-icon label-width="160px">
            <el-form-item label="登录名" required prop="userName" style="float: left">
              <el-input v-model="form.userName"
                        placeholder="请输入登录名"
                        style="width: 300px"
                        clearable autocomplete="off" show-word-limit
                        required>
              </el-input>
              <el-input v-model="form.authorityId" type="hidden"/>
            </el-form-item>
            <el-form-item label="姓名" required prop="userAlias">
              <el-input v-model="form.userAlias"
                        placeholder="请输入姓名"
                        onkeyup="this.value=this.value.replace(/[, ]/g,'')"
                        style="width: 300px"
                        clearable autocomplete="off" show-word-limit
                        required>
              </el-input>
            </el-form-item>
            <el-form-item label="密码" required prop="passWord" style="float: left">
              <el-input v-model="form.passWord"
                        placeholder="请输入密码"
                        onkeyup="this.value=this.value.replace(/[, ]/g,'')"
                        style="width: 300px"
                        clearable autocomplete="off" show-word-limit
                        required>
              </el-input>
              <el-input v-model="form.roleId" style="width: 50%;" type="hidden"></el-input>
              <el-input v-model="form.areaId" style="width: 50%;" type="hidden"></el-input>
              <el-input v-model="form.createBy" style="width: 50%;" type="hidden"></el-input>
            </el-form-item>
            <el-container>
              <el-aside style="width: 330px">
                <el-form-item label="角色" required>
                  <el-select v-model="selectvalue2" placeholder="请选择角色" clearable="handleNodeClick" filterable>
                    <el-option
                        v-for="item in treeData"
                        :key="item.roleId"
                        :label="item.roleName"
                        :value="item.roleId"
                        @click="handleCheckChange"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!--                <el-button type="primary" @click="tosign">用户签名</el-button>-->
                <el-form-item label="工具箱" style="float: left">
                  <el-select v-model="toolBoxSelect" placeholder="请选择工具箱" clearable="handleNodeClick">
                    <el-option
                        v-for="item in toolBox"
                        :key="item.toolId"
                        :label="item.toolName"
                        :value="item.toolId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="安全帽" style="float: left;">
                  <el-select v-model="capsSelect" placeholder="请选择安全帽" clearable="handleNodeClick" filterable>
                    <el-option
                        v-for="item in caps"
                        :key="item.capIndex"
                        :label="item.localName"
                        :value="item.capIndex"
                    >
                      <el-row>
                        <el-col :span="12">
                          <span style="float: left">{{ item.capIndex + ":" + "&nbsp;&nbsp;&nbsp;"}}</span>
                        </el-col>
                        <el-col :span="12">
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.localName }}</span>
                        </el-col>
                      </el-row>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-aside>
            </el-container>
            <el-form-item label="管理区域" required>
              <el-cascader
                  v-model="casvalue"
                  :options="AreaData"
                  placeholder="区域信息"
                  ref="cascaderAddr"
                  :props="setKesLabel"
                  :show-all-levels="false"
                  @change="areaCheckChange"
              >
                <template v-slot="{ node, data }">
                  <span>{{ data.areaName }}</span>
                  <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                </template>
              </el-cascader>

            </el-form-item>
            <el-form-item label="上传签名" status-icon label-width="160px">
              <!--              action="http://114.132.200.17:8080/user/saveSign"-->
              <el-upload
                  class="avatar-uploader"
                  :action="this.ip+'/user/saveSign'"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-preview="handlePictureCardPreview"
                  ref="upload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>

            </el-form-item>
            <!--            <el-main style="margin-top: -20px">-->

            <!--                <div class="esigh-result">-->
            <!--                  <img v-if="resultImg" :src="resultImg" alt="" style="width: 100px; height: 100px">-->
            <!--                </div>-->
            <!--            </el-main>-->
          </el-form>
          <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: -50px" @click="dialogFormVisible = false">关闭</el-button>
                        <!--                        <el-popconfirm title="确定删除此用户？" width="150" @confirm="del(scope.row.userId)">-->
                        <!--                <template #reference>-->
                        <!--                  <el-button type="danger">删除</el-button>-->
                        <!--                </template>-->
                        <!--              </el-popconfirm>-->
                        <!--                        <el-popconfirm title="确定添加此用户？" width="150" @confirm="onSubmit('form')">-->
                        <!--                          <template #reference>-->
                        <el-button style="margin-top: -50px" type="primary" @click="onSubmit('form')"
                                   :disabled="disabled">确定</el-button>
                        <!--                            </template>-->
                        <!--                          </el-popconfirm>-->
                      </span>
          </template>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="编辑用户" width="80%" v-model="dialogVisible" :before-close="cancel" :close-on-click-modal="false">
          <el-form ref="editform" :model="editform" :rules="rules" label-width="80px">
            <el-form-item label="用户名" status-icon label-width="160px" prop="userName" style="float:left;">
              <el-input v-model="editform.userName" style="width: 300px;"></el-input>
              <!--              <el-input v-model="form.authorityId" type="hidden"/>-->
            </el-form-item>
            <el-form-item label="姓名" status-icon label-width="160px">
              <el-input v-model="editform.userAlias" style="width: 300px;"></el-input>
            </el-form-item>
            <!--            <el-form-item label="密码" type="hidden">-->
            <!--              <el-input v-model="editform.passWord" style="width: 50%;" type="hidden"></el-input>-->
            <!--            </el-form-item>-->
            <el-container>
              <el-aside style="margin-left: 80px">
                <el-form-item label="角色" required>
                  <!--              <el-tree :data="treeData" :props="defaultProps" @check="handleCheckChange" show-checkbox></el-tree>-->
                  <el-select v-model="selectvalue2" placeholder="请选择角色" clearable="handleNodeClick" filterable>
                    <el-option
                        v-for="item in treeData"
                        :key="item.roleId"
                        :label="item.roleName"
                        :value="item.roleId"
                        @click="handleCheckChange">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="密码" prop="passWord">
                  <el-input v-model="editform.passWord" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="工具箱">
                  <el-select v-model="toolBoxSelectUpdate" placeholder="请选择工具箱" clearable="handleNodeClick">
                    <el-option
                        v-for="item in toolBox"
                        :key="item.toolId"
                        :label="item.toolName"
                        :value="item.toolId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="安全帽">
                  <el-select v-model="capsSelectUpdate" placeholder="请选择安全帽" clearable="handleNodeClick" @click="getCaps" >
                    <el-option
                        v-for="item in caps"
                        :key="item.capIndex"
                        :label="item.localName"
                        :value="item.capIndex"
                    >
                      <el-row>
                        <el-col :span="12">
                          <span style="float: left">{{ item.capIndex + ":"}}</span>
                        </el-col>
                        <el-col :span="12">
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.localName }}</span>
                        </el-col>
                      </el-row>
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="选择签名" style="margin-top: 20px">
                  <!--                  action="http://114.132.200.17:8080/user/saveSign"-->
                  <el-upload
                      class="avatar-uploader"
                      :action="this.ip+'/user/saveSign'"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-preview="handlePictureCardPreview"
                      ref="upload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-aside>

              <el-main style="margin-left: 140px;margin-top: -20px">
                <el-form-item label="管理区域">
                  <el-cascader
                      v-model="casvalue"
                      :options="AreaData"
                      placeholder="区域信息"
                      ref="cascaderAddr"
                      :props="setKesLabel"
                      :key="modalKey"
                      :show-all-levels="false"
                      @change="areaCheckChange">
                    <template v-slot="{ node, data }">
                      <span>{{ data.areaName }}</span>
                      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                    </template>
                  </el-cascader>
                  <el-input v-model="editform.areaId" style="width: 50%;" type="hidden"></el-input>
                  <el-input v-model="editform.createBy" style="width: 50%;" type="hidden"></el-input>
                  <el-input v-model="editform.updateBy" style="width: 50%;" type="hidden"></el-input>
                </el-form-item>
                <el-form-item label="现存签名" style="margin-top: 30px">
                  <el-image
                      class="avatar"
                      :src="url"
                      v-model="editform.userSign"></el-image>
                </el-form-item>
              </el-main>
            </el-container>

          </el-form>
          <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: 20px" @click="cancel">关闭</el-button>
                        <el-button style="margin-top: 20px" type="primary"
                                   @click="editSubmit('editform')">确定</el-button>
                      </span>
          </template>
        </el-dialog>
      </div>
      <div>
        <!--        <el-dialog title="用户签名" width="100%" v-model="singVisible" :fullscreen="true">-->
        <!--          <div id="app" class="esign">-->
        <!--            <div class="esign-box">-->
        <!--              <vue-esign class="esignature" ref="esign" :width="800" :height="300" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" v-model:bgColor="bgColor" />-->
        <!--            </div>-->
        <!--            <div class="esigh-btns">-->
        <!--              <button @click="handleReset">清空画板</button>-->
        <!--              <button @click="handleGenerate">生成图片</button>-->
        <!--            </div>-->
        <!--            <div class="esigh-result">-->
        <!--              <el-upload-->
        <!--                  class="avatar-uploader"-->
        <!--                  action="https://jsonplaceholder.typicode.com/posts/"-->
        <!--                  :show-file-list="false"-->
        <!--                  :on-success="handleAvatarSuccess"-->
        <!--                  :before-upload="beforeAvatarUpload">-->
        <!--                <img v-if="resultImg" :src="resultImg" class="avatar" alt="">-->
        <!--                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--              </el-upload>-->
        <!--&lt;!&ndash;              <img v-if="resultImg" :src="resultImg" alt="">&ndash;&gt;-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </el-dialog>-->
      </div>
    </el-main>
  </el-container>


</template>

<script>
import request from "@/util/request";

export default {
  name: "UserList",
  data() {
    let validateStruct_Name = (rule, value, callback) => {
      console.log("kaisidiyibd")
      console.log(value)
      if (value === this.repeatName && this.dialogVisible === true) {
        callback();
      } else {
        request.get('/user/getUserByName', {
          params: {
            userName: value
            // areaId:this.parentNodeDate.parentId
          }
        }).then(res => {
          if (res == 0) {
            callback()
          } else if (res == 1) {
            callback(new Error("用户名重复，重新输入！"))
            // window.alert("该用户已存在,添加失败!")
          }
        })
      }
    };
    const treeData = [];
    const AreaData = [];
    return {
      dialogImageUrl: '',
      ip: localStorage.getItem("ip"),//ip地址
      url: '',
      srcList: [
        'https://jc.yunzhankeji.cloud/resource/082750/image/jyzz.png?t=1690787212362'
      ],
      treeData: JSON.parse(JSON.stringify(treeData)),

      AreaData: JSON.parse(JSON.stringify(AreaData)),
      defaultProps: {
        children: 'children',
        label: 'roleName'
      },
      areaProps: {
        children: 'children',
        label: 'areaName'
      },
      form: {},
      editform: {},
      name: '',
      typeqqq: [],
      dialogFormVisible: false,
      dialogVisible: false,
      singVisible: false,
      findUser: '',
      session: sessionStorage.getItem("createBy"),
      tablee: [],
      multipleSelection: [],
      show: false,
      scrollHeight: '400px',
      scrollWidth: '100%',
      roleKey: [],
      areaKey: [],
      editRoleKey: [],
      roleId: [],
      areaArray: [],
      roleArray: [],
      arid: [],
      shuru: '',
      currentPage: 1,
      pageSize: 10,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      value: true,
      selectvalue: '',
      selectvalue2: '',
     //工具箱
      toolBox: [],
      //安全帽
      caps: [],
      //工具箱新建下拉框
      toolBoxSelect: '',
      //安全帽新建下拉框
      capsSelect: '',
      //工具箱修改下拉框
      toolBoxSelectUpdate:'',
      //安全帽修改下拉框
      capsSelectUpdate:'',
      casvalue: [],
      modalKey: 0,
      setKesLabel: {
        value: 'areaId',
        label: 'areaName',
        children: 'children',
        multiple: true,
      },
      repeatName: '',//判断名字是否重复
      repeatName1: '',//判断密码是否为空
      repeatName2: '',//判断角色是否为空
      rules: {
        userName: [
          {required: true, min: 1, max: 50, message: '用户名不能为空', trigger: 'blur'},
          {validator: validateStruct_Name, required: true, message: '用户名重复或不规范，重新输入', trigger: 'blur'}
        ],
        userAlias: [
          {required: true, min: 1, max: 50, message: '姓名不能为空', trigger: 'blur'},
          // {  validator: validateStruct_Name,required: true, message: '用户名重复或不规范，重新输入', trigger: 'blur'}
        ],
        passWord: [
          {required: true, min: 1, max: 50, message: '密码不能为空', trigger: 'blur'},
          // {  validator: validateStruct_Name,required: true, message: '用户名重复或不规范，重新输入', trigger: 'blur'}
        ],
      },
      imageUrl: '',
      canvasDom: null,
      ctx: null,
      isDowm: false,
      lineWidth: 6, // 画笔的线条粗细
      lineColor: "#000000", // 画笔的颜色
      bgColor: '', // 画布的背景颜色
      resultImg: '', // 最终画布生成的base64图片
      isCrop: true, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      isClearBgColor: false, //是否在清空时，也清空画布背景
      format: "image/png", //生成图片的格式  image/jpeg(jpg格式下生成的图片透明背景会变黑色请慎用或指定背景色)
      // quality: 0.92,
      upload: {
        // 设置上传的请求头部
        // headers: { token: getToken(), "tenant-id": getTenantId() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/media/upload/coursefile",
      },
      disabled: false,
      disabled1: false,
      testMap: {
        username: "isptest",
        passwd: "579b7a60029848d0fc88d26bc7886fa26b593e48df143040b500c6a7cf5b6c37",
        time_stamp: "1694424423998"
      },
    }
  },
  // mounted() {
  //   this.canvasDom = this.$refs.saveCanvas;
  //   this.ctx = this.canvasDom.getContext("2d"); //获得 2d 上下文对象
  // },
  created() {
    // this.dialogFormVisible = false
    // this.show = false
    // console.log(sessionStorage.getItem("createBy"))
    this.load();
    this.query();
  },
  methods: {
    //工具箱下拉框数据
    getToolBox() {
      request.get('/order/getToolBox').then(res => {
        this.toolBox = res.data;
      })
    },
    //安全帽下拉框数据
    getCaps() {
      request.get('/cap/usreUserQueryList').then(res => {
        this.caps = res;
      })
    },
    //打开修改弹窗安全帽下拉框数据
    getCaps1() {
      request.get('/cap/queryList').then(res => {
        this.caps = res;
      })
    },
    uploadSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res)
      this.form.userSign = file.response.data
      this.url = res.data
    },
    editUploadSuccess(res) {
      this.editform.userSign = res.data
    },
    getStructByName(rule, value, callback) {
      request.get('/user/getUserByName', {
        params: {
          userName: value
          // areaId:this.parentNodeDate.areaId
        }
      }).then(res => {
        if (res.code === "0") {
          callback()
        } else {
          callback(new Error("用户名重复，重新输入！"))
        }
      })
    },
    load() {
      request.post("/role/tree").then(res => {
        this.treeData = res.data.lists
        for (let i = 0; i < res.data.lists.length; i++) {
          // if (res.data.lists[i].authorityId == 1) {
          //   res.data.lists[i].authorityId = "查看"
          // } else if (res.data.lists[i].authorityId == 2) {
          //   res.data.lists[i].authorityId = "修改"
          // } else if (res.data.lists[i].authorityId == 3) {
          //   res.data.lists[i].authorityId = "删除"
          // }
          // this.tablee[i].createDate = this.formatDate(res.data.lists[i].createDate, "yyyy-MM-dd hh:mm:ss");
        }
      })
    },
    xinjian() {
      this.imageUrl = '';
      this.selectvalue2 = ''
      this.areaArray = [];
      this.casvalue = [];
      this.capsSelect = '';
      this.form = {
        userName: '',
      }
      this.dialogFormVisible = true
      this.repeatName = this.form.userName
      this.area()
      request.get('/area/useruselist').then(res => {
        this.AreaData = res.data.structList;

      })
      request.get('/area/useruselist').then(res => {
        this.AreaData = res.data.structList;

      })
      this.toolBox = [];
      this.caps = [];
      this.getToolBox();
      this.getCaps();
      // this.$refs['upload'].clearFiles()
      // this.arid =[];
    },
    onSubmit(formName) {
      console.log(this.form)
      this.disabled = true
      this.repeatName = this.form.userName
      this.repeatName1 = this.form.passWord
      // this.repeatName2 = this.form.roleId
      this.repeatName2 = this.form.userAlias
      this.form.roleId = this.selectvalue2
      this.form.areaId = "," + this.areaArray + ","
      this.form.createBy = sessionStorage.getItem('userName')
      // this.form.areaId = this.areaArray + ""
      // if (this.selectvalue2.length == 1) {
      this.$refs[formName].validate((valid) => {
        this.repeatName = this.form.userName
        this.repeatName1 = this.form.passWord
        // this.repeatName2 = this.form.roleId
        this.repeatName2 = this.form.userAlias
        //工具箱下拉框
        this.form.toolId=this.toolBoxSelect
        //安全帽下拉框
        this.form.capIndex=this.capsSelect
        if (valid) {
          // this.$alert('确定添加该用户吗', '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     console.log(action)
          //
          //   }
          // });
          request.post("/user/createUser", this.form).then(res => {

            this.tablee = res.data
            this.dialogFormVisible = false
            this.query()
            // if (res.code === '0') {
            //   this.disabled = true
            // }
          })
          setTimeout(() => {
            this.disabled = false
          }, 3000)
          //
        } else {
          if (this.repeatName == null || this.repeatName == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入用户名!'
            });
            setTimeout(() => {
              this.disabled = false
            }, 3000)
            return false;
          } else if (this.repeatName1 == null || this.repeatName1 == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入密码!'
            });
            setTimeout(() => {
              this.disabled = false
            }, 3000)
            return false;
          } else if (this.repeatName2 == null || this.repeatName2 == "") {
            console.log('error submit!!');
            this.$message({
              type: 'error',
              // message: '用户名重复,请重新输入!'
              message: '请输入姓名!'
            });
            setTimeout(() => {
              this.disabled = false
            }, 3000)
            return false;
          }
        }
      });
      // } else {
      //   this.$message.error("新建用户角色只能选择一个,保存失败!")
      // }
    },
    editSubmit(formName) {
      //工具箱下拉框
      this.editform.toolId=this.toolBoxSelectUpdate
      this.editform.roleId = this.selectvalue2
      //安全帽下拉框
      this.editform.capIndex=this.capsSelectUpdate
      if (this.areaArray.length === 0) {
        // this.editform.areaId = "," + this.areaArray + ","
      } else {
        this.editform.areaId = "," + this.areaArray + ","
        this.form.createBy = sessionStorage.getItem('userName')
        this.editform.updateBy = sessionStorage.getItem('userName')
      }
      console.log(this.roleArray)
      console.log(this.roleKey)
      this.$refs[formName].validate((valid) => {
        // this.repeatName = this.editform.userName
        if (valid) {
          request.post("/user/update", this.editform).then(res => {
            if (res.code === '0') {
              this.tablee = res.data
              this.dialogVisible = false
              this.query()
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
            } else {
              this.$message({
                type: 'info',
                message: '区域修改失败，有未检测的工单'
              });
            }
          })
        } else {
          console.log('error submit!!');
          this.$message({
            type: 'error',
            message: '修改数据不正确,请重新输入!'
          });
          return false;
        }
      });
    },
    update(row) {
      this.getCaps1();
      this.imageUrl = '';
      this.casvalue = [];
      this.areaArray = [];
      this.editform = JSON.parse(JSON.stringify(row))
      this.url = row.userSign
      this.repeatName = JSON.parse(JSON.stringify(row.userName));
      this.dialogVisible = true;
      for (let i = 0; i < this.editform.areaId.toString().split(",").length; i++) {
        this.casvalue.push(parseInt(this.editform.areaId.toString().split(",")[i]));
      }
      //工具箱下拉框
      this.toolBox = [];
      this.getToolBox()
      this.toolBoxSelectUpdate=this.editform.toolId;
      //安全帽下拉框
      this.caps = [];
      this.getCaps()
      this.capsSelectUpdate = this.editform.capIndex;
      request.post("/cap/updateAllocationToZero", this.editform.capIndex).then(res => {
        console.log(res)
      })
      console.log(row);
      // request.post("/role/userUseList", {}).then(res => {
      //   this.treeData = res.data.lists
      //   console.log(res.data.lists)
      //   for (let i = 0; i < res.data.lists.length; i++) {
      //     console.log(res.data.lists[i].roleName)
      //     console.log(res.data.lists[i].roleId)
      //   }
      //   // if (this.editform.roleId.size == 1) {
      //     // this.roleKey.push(this.editform.roleId);
      this.selectvalue2 = this.editform.roleId
      //   // } else {
      //   //   this.roleKey = this.editform.roleId.toString().split(",");
      //   // }
      //   console.log(this.roleKey)

      if (this.editform.areaId.length == 1) {
        this.areaKey.push(this.editform.areaId);
      } else {
        this.areaKey.push(this.editform.areaId.toString().split(","));
      }

      //   // console.log(this.typeqqq )
      // })
      request.get('/area/useruselist').then(res => {
        // console.log(res);
        this.AreaData = res.data.structList;

      })

      // request.post("/user/getpwd", {
      //   params: {
      //     name: row.userName
      //   }
      // }).then(res => {
      //   res.data
      // })
    },
    del(userId, capIndex) {
      request.post("/cap/updateAllocationToZero", capIndex).then(res => {
        console.log(res)
      })
      request.delete("/user/delete/" + userId).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.query()
        } else {
          this.$message({
            message: '删除失败！',
            type: 'error'
          });
        }
      })
    },
    query() {
      this.tablee = []
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        "roleId": this.selectvalue
      }
      request.post("/user/list", userMap).then(res => {


        console.log(res.data.lists[0].userName)
        console.log(sessionStorage.getItem("userName"))
        console.log(res.data.lists)
        console.log(typeof res.data.lists)
        this.tablee = res.data.lists
        this.total = res.data.total
        if (res.code === '500') {
          this.dialogVisible = false
        }
      })
    },
    chaxun() {
      this.shuru = ''
      this.selectvalue = ''
      this.currentPage = 1
      this.load();
      this.query();
    },
    select() {
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        "roleId": this.selectvalue
      }
      request.post("user/list", userMap).then(res => {
        this.tablee = res.data.lists
        this.total = res.data.total
      })
    },
    area() {
      request.get('/area/list').then(res => {
        // console.log(res);
        this.AreaData = res.data.structList;

      })
    },
    // handleCheckChange(data, checked, indeterminate) {
    handleCheckChange() {
      console.log(this.selectvalue2)

      // this.roleArray = [];
      // if (checked.checkedKeys != null && checked.checkedKeys.length>0) {
      //   if (checked.checkedKeys.length > 1 ) {
      //     Object.keys(checked.checkedNodes).forEach(key=>{
      //       Object.keys(checked.checkedNodes[key]).forEach(keys=>{
      //         // if (checked.checkedNodes[key].areaLevel === 4) {
      //           if (!this.roleArray.includes(checked.checkedNodes[key].roleId)){
      //             this.roleArray.push(checked.checkedNodes[key].roleId) ;
      //           }
      //         // }
      //         let arr =keys;
      //         console.log("arr值:"+arr)
      //       });
      //     });
      //   }else {
      //     this.roleArray =checked.checkedKeys;
      //   }
      // } else {
      //   this.roleArray = [];
      // }
      // console.log(data.roleId)
      // console.log(data)
      // // console.log(checked)
      // console.log(this.roleArray)
      // this.form.roleId = data.roleId
      // console.log(this.form.roleId)
    },
    editRoleFun(data, checked) {
      this.roleArray = [];
      if (checked.checkedKeys != null && checked.checkedKeys.length > 0) {
        if (checked.checkedKeys.length > 1) {
          Object.keys(checked.checkedNodes).forEach(key => {
            Object.keys(checked.checkedNodes[key]).forEach(keys => {
              if (checked.checkedNodes[key].areaLevel === 2) {
                if (!this.roleArray.includes(checked.checkedNodes[key].roleId)) {
                  this.roleArray.push(checked.checkedNodes[key].roleId);
                }
              }
              let arr = keys;
              console.log("arr值:" + arr)
            });
          });
          // console.log(arr)
        } else {
          this.roleArray = checked.checkedKeys;
        }
        // console.log(this.tvDepartmentSelArr+"-----555");
        // console.log( this.tvDepartmentSelArr+"-----111");
      } else {
        this.roleArray = [];
        // console.log(this.tvDepartmentSelArr+"-----777");
      }
      console.log("tvDepartmentSelArr数组值:" + this.roleArray)
      console.log(checked.checkedKeys)
    },
    areaCheckChange(data, checked, casvalue) {
      console.log(casvalue);
      console.log(this.setKesLabel.value)
      console.log(data)
      console.log(checked)
      console.log(this.casvalue)
      this.areaArray = [];
      for (let i = 0; i < this.casvalue.length; i++) {
        // console.log(this.$refs.cascaderAddr.getCheckedNodes()[i].pathLabels)
        for (let j = 0; j < this.casvalue[i].length; j++) {
          if (j == 2) {
            console.log(2222);
            // this.form.areaId = this.casvalue[i][j];
            this.areaArray.push(this.casvalue[i][j]);
            // this.areaArray = this.casvalue[i][j];
          }
        }
      }

      console.log("areaArray数组值:" + this.areaArray)
      // this.areaArray = [];
      // if (checked.checkedKeys != null && checked.checkedKeys.length>0) {
      //   if (checked.checkedKeys.length > 1 ) {
      //     Object.keys(checked.checkedNodes).forEach(key=>{
      //       Object.keys(checked.checkedNodes[key]).forEach(keys=>{
      //         if (checked.checkedNodes[key].areaLevel === 5) {
      //         if (!this.areaArray.includes(checked.checkedNodes[key].areaId)){
      //           this.areaArray.push(checked.checkedNodes[key].areaId) ;
      //         }
      //         }
      //         let arr =keys;
      //         console.log("arr值:"+arr)
      //       });
      //     });
      //   }else {
      //     this.areaArray =checked.checkedKeys;
      //   }
      // } else {
      //   this.areaArray = [];
      // }
      // console.log("tvDepartmentSelArr数组值:"+this.areaArray)
      // console.log(checked.checkedKeys)
      // this.arid.push(data.areaId)
    },
    editAreaCheckChange(data, checked) {
      // console.log(casvalue);
      // console.log(this.setKesLabel.value)
      // console.log(data)
      // console.log(checked)
      // console.log(this.casvalue)
      // this.areaArray = [];
      // for (let i = 0; i < this.casvalue.length; i++) {
      //   // console.log(this.$refs.cascaderAddr.getCheckedNodes()[i].pathLabels)
      //   for (let j = 0; j < this.casvalue[i].length; j++) {
      //     if (j == 4) {
      //       console.log(2222);
      //       // this.form.areaId = this.casvalue[i][j];
      //       this.areaArray.push( this.casvalue[i][j]);
      //       // this.areaArray = this.casvalue[i][j];
      //     }
      //   }
      // }
      // console.log("areaArray数组值:" + this.areaArray)
      this.areaArray = [];
      if (checked.checkedKeys != null && checked.checkedKeys.length > 0) {
        if (checked.checkedKeys.length > 1) {
          Object.keys(checked.checkedNodes).forEach(key => {
            Object.keys(checked.checkedNodes[key]).forEach(keys => {
              if (checked.checkedNodes[key].areaLevel === 3) {
                if (!this.areaArray.includes(checked.checkedNodes[key].areaId)) {
                  this.areaArray.push(checked.checkedNodes[key].areaId);
                }
              }
              let arr = keys;
              console.log("arr值:" + arr)
            });
          });
        } else {
          this.areaArray = checked.checkedKeys;
        }
      } else {
        this.areaArray = [];
      }
      console.log("tvDepartmentSelArr数组值:" + this.areaArray)
      console.log(checked.checkedKeys)
      this.arid.push(data.areaId)
    },
    handleNodeClick() {
      // console.log(data);
      // console.log(data.roleId);
      this.findUser = this.selectvalue
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": this.shuru,
        roleId: this.findUser
      }
      request.post("/user/list", userMap).then(res => {
        if (res.code === '0') {
          this.tablee = res.data.lists
          this.total = res.data.total
        } else {
          this.tablee = [];
        }

      })
    },
    cancel() {
      this.dialogFormVisible = false
      this.dialogVisible = false
      request.post("/cap/updateAllocationToOne", this.editform).then(res => {
        console.log(res)
      })
      this.editform = {};
      this.roleArray = [];
      this.areaArray = [];
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.query();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.query();
    },
    changeSwitch(row) {
      // this.roleKey = [];
      // this.areaKey = [];
      // if (this.editform.roleId.size == 1) {
      //   this.roleKey.push(this.editform.roleId);
      // } else {
      //   this.roleKey= this.editform.roleId.toString().split(",");
      // }
      // console.log(this.roleKey)
      // if (this.editform.areaId.length == 1) {
      //   this.areaKey.push(this.editform.areaId);
      // } else {
      //   this.areaKey= this.editform.areaId.toString().split(",");
      // }
      console.log(row)
      console.log(row.userId)
      this.editform = JSON.parse(JSON.stringify(row))
      this.editform.roleId = row.roleId
      this.editform.areaId = row.areaId
      this.form.createBy = sessionStorage.getItem('userName')
      this.editform.updateBy = sessionStorage.getItem('userName')
      request.post("/user/update", this.editform).then(res => {
        // this.tablee = res.data
        console.log(res)
        this.dialogVisible = false
        this.query()
        // this.roleKey = [];
        // this.areaKey = [];
      })
      request.post("/cap/updateAllocationToZero", this.editform.capIndex).then(res => {
        console.log(res)
      })
    },
    handleChange(value) {
      console.log(value);
    },
    saveImg() {
      // const img = this.ctx.getImageData(0, 0, 600, 400);
      const url = this.canvasDom.toDataURL();
      const a = document.createElement("a");
      a.download = "图片";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, 600, 400);
    },
    handleReset() {
      this.$refs.esign.reset();
    },
    // 生成签字图  保存按钮
    handleGenerate() {

      this.$refs.esign
          .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
          .then((res) => {
            this.resultImg = res;
            this.singVisible = false;
            // 转成文件
            // var blob = this.dataURLtoBlob(res)
            // var tofile = this.blobToFile(blob, '签名.jpg')
            let map = {
              "sign": this.resultImg
            }
            request.post("/user/saveSign", map).then(res => {
              console.log(res)
              sessionStorage.setItem("qm", res.data.lists)
              console.log(sessionStorage.getItem("qm"))
            })
            // console.log(tofile)
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "warning",
              message: "请签名后再生成签字图片",
            });
          });
      setTimeout(() => {
        // 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
        // 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储
        console.log('我是签字后的base64图片', this.resultImg);
      }, 200);
      // this.dialogVisible = false;
    },
    // 将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {type: mime})
    },
    // 将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    handleAvatarSuccess(res, file) {
      // this.resultImg = URL.createObjectURL(file.raw);
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(file)
      console.log(file.response.data)
      this.editform.userSign = file.response.data
    },
    tosign() {
      // this.$router.push({path:'sign', query:{}});
      this.singVisible = true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
      console.log(file.response.data)
      // this.dialogImageUrl = file.url;
      this.dialogImageUrl = file.response.data;
      this.singVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传签名图片只能是 JPG 或者是 PNG 格式!');
      }
      // if (!isPNG) {
      //   this.$message.error('上传签名图片只能是 PNG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!');
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 张图片，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    serviceTest() {
      // let USE_UNT_NAME = "福州市园开安筑建设有限公司";
      // let USE_UNT_COD = "91350000154586155C";
      // let OIDNO = "TA121529";
      // let map = new Map;
      let map = {
        "USE_UNT_NAME": "wq测试企业（综合）",
        "USE_UNT_COD": "91350000154586155C",
        "OIDNO": "RD40589"
      }
      // map = JSON.stringify(map)
      // map.set(USE_UNT_NAME, "福州市园开安筑建设有限公司")
      // map.set(USE_UNT_COD, "91350000154586155C")
      // map.set(OIDNO, "TA121529")
      // map.setUSE_UNT_NAME(USE_UNT_NAME)
      // map.setUSE_UNT_COD(USE_UNT_COD)
      // map.setOIDNO(OIDNO)
      // let data = {
      //   'map': map
      // }
      console.log(typeof map)
      // request.post("http://211.138.144.117:9510/api/det/service/auth?username="+map.username+"&passwd="+map.passwd+"&time_stamp="+map.time_stamp
      request.post("/user/jkTest", map).then(res => {
        console.log(new Date().getTime())
        console.log(res)
        // for (let i = 0; i < res.data.length; i++) {
        //   console.log(res.data[i].token)
        //
        // }
        // console.log(res.data)
      })
      // axios.post("http:/211.138.144.117:9510/api/det/service/auth",map).then(res => {
      //   console.log(res)
      // })
    },
  },
}
</script>

<style>
/*.esign {*/
/*  max-width: 1000px;*/
/*  margin: auto;*/
/*  padding: 10px;*/
/*}*/
/*.esigh-btns button{*/
/*  color: #fff;*/
/*  height: 40px;*/
/*  width: 100px;*/
/*  font-size: 16px;*/
/*  margin-right: 10px;*/
/*  outline: none;*/
/*  border-radius: 4px;*/
/*  background: #F60;*/
/*  border: 1px solid transparent;*/
/*}*/
/*.esigh-btns button:active{*/
/*  color:#fff;*/
/*  box-shadow: 0px 0px 50px orangered inset;*/
/*}*/
/*.esigh-result {*/
/*  margin-top: 10px;*/
/*}*/
/*.esigh-result img {*/
/*  display: block;*/
/*  max-width: 100%;*/
/*  height: auto;*/
/*  border: 1px solid #ececee;*/
/*}*/
/*.esignature {*/
/*  margin: 10px 0;*/
/*  border: 2px solid #ccc;*/
/*}*/

.avatar-uploader .el-upload {
  border: 1px dashed #00a5fe;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  border: 1px dashed #00a5fe;
}
</style>